import { Locale } from '../wrappers/Locale';
/**
 * Reseller co-labeling: holds the active brand and dispatches it to
 * app-registered adapters, which translate the brand colors into their
 * app's own theming (POS/admin write Nuxt UI `--ui-*` variables,
 * old admin rewrites the Vuetify theme objects).
 */
class BrandThemeService {
    adapters = [];
    active = null;
    registerAdapter(fn) {
        this.adapters.push(fn);
        // If branding is already active when an adapter registers, sync immediately
        // so late-registered adapters (e.g. after Vuetify init) don't miss the state.
        if (this.active)
            fn(this.active);
    }
    apply(brand) {
        if (this.active?.slug !== brand.slug) {
            console.info(`[BrandThemeService] Activating co-label for reseller "${brand.slug}".`);
        }
        this.active = brand;
        this.adapters.forEach(fn => fn(brand));
    }
    clear() {
        this.active = null;
        this.adapters.forEach(fn => fn(null));
    }
    applyFromLocale() {
        const brand = Locale.getBrand();
        if (brand)
            this.apply(brand);
        else
            this.clear();
    }
}
export const brandTheme = new BrandThemeService();
export default brandTheme;
//# sourceMappingURL=BrandThemeService.js.map